module.exports = __webpack_public_path__ + "static/img/tu6.d48ee8b2.png";